import constants from "../common/restService/constant";
import GatewayGet from "../common/restService/GatewayGet";

let props = {};
let inputObj = {};
let InputJSONString = "";
props["query"] = constants.serviceRoot;
props["headers"] = constants.serviceHeaders;

export const getSegments = async () => {
    // InputJSONString = JSON.stringify(input);
    inputObj["Activity"] = "F4_WF_SEGMENTS";
    inputObj["Input"] = "";
    props.input = inputObj;

const result = await GatewayGet(props, props.input);
    return result;
  };

  export const getUserDetails = async () => {
    // InputJSONString = JSON.stringify(input);
    inputObj["Activity"] = "GET_USER_DETAILS";
    inputObj["Input"] = "";
    props.input = inputObj;

const result = await GatewayGet(props, props.input);
    return result;
  };

   

  

  export const getApproverWorklist = async (input) => {
     InputJSONString = JSON.stringify(input);
    inputObj["Activity"] = "APPR_WLIST";
    inputObj["Input"] = InputJSONString;
    props.input = inputObj;

const result = await GatewayGet(props, props.input);
    return result;
  };

  export const FOFinanceApprove = async (input) => {
    InputJSONString = JSON.stringify(input);
   inputObj["Activity"] = "FO_FINANCE_APPROVE";
   inputObj["Input"] = InputJSONString;
   props.input = inputObj;

const result = await GatewayGet(props, props.input);
   return result;
 };

 export const FOInvoiceApprove = async (input) => {
    InputJSONString = JSON.stringify(input);
   inputObj["Activity"] = "FO_INVOICE_APPROVE";
   inputObj["Input"] = InputJSONString;
   props.input = inputObj;

const result = await GatewayGet(props, props.input);
   return result;
 };

 export const FOFinanceReject = async (input) => {
    InputJSONString = JSON.stringify(input);
   inputObj["Activity"] = "FO_FINANCE_REJECT";
   inputObj["Input"] = InputJSONString;
   props.input = inputObj;

const result = await GatewayGet(props, props.input);
   return result;
 };

 export const FOInvoiceReject = async (input) => {
    InputJSONString = JSON.stringify(input);
   inputObj["Activity"] = "FO_INVOICE_REJECT";
   inputObj["Input"] = InputJSONString;
   props.input = inputObj;

const result = await GatewayGet(props, props.input);
   return result;
 };

 export const UpdateComments = async (input) => {
    InputJSONString = JSON.stringify(input);
   inputObj["Activity"] = "Q_UPDATE_TENDRESP_NOTES";
   inputObj["Input"] = InputJSONString;
   props.input = inputObj;

const result = await GatewayGet(props, props.input);
   return result;
 };

